import axios from "axios"

export const getIfUserExistance = (email: string) => {
    return axios.get<boolean>(`user/checkIfExistByEmail/${email}`);
}
